module.exports = __webpack_public_path__ + "static/unilever-5a7f283cd2613fcd868d6ec423849b32.png";